import HeroSection from "./components/HeroSection";
import useSEO from '@/hooks/useSEO';
import AdvantagesSection from "./components/AdvantagesSection";
import MarketDashboard from "./components/MarketDashboard";
import AccountTypesSection from "./components/AccountTypesSection";
import ProsConsSection from "./components/ProsConsSection";
import OnboardingSection from "./components/OnboardingSection";
import FundingSection from "./components/FundingSection";
import ExpertVerdictSection from "./components/ExpertVerdictSection";
import FaqSection from "./components/FaqSection";
import { Link } from "react-router-dom";
import { brokers } from "@/data/brokers";

function FinalCTA() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden bg-[#0B0F19]">
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/3 w-[500px] h-[500px] bg-[#7C3AED]/10 rounded-full blur-[120px]" />
        <div className="absolute bottom-0 right-1/4 w-[300px] h-[300px] bg-[#10B981]/5 rounded-full blur-[100px]" />
      </div>

      <div className="relative max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#F8FAFC] mb-6">
          Ready to Start Trading{" "}
          <span className="text-gradient">with XM?</span>
        </h2>
        <p className="text-lg text-[#94A3B8] mb-10 max-w-2xl mx-auto">
          Join over 5 million traders worldwide. Get your $30 no-deposit bonus and start trading with zero risk.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={brokers.xm.href}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-8 py-4 bg-[#7C3AED] hover:bg-[#8B5CF6] text-white font-semibold rounded-lg transition-all hover:shadow-xl hover:shadow-[#7C3AED]/25 group whitespace-nowrap"
          >
            <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center">
              <i className="ri-arrow-right-line text-white group-hover:translate-x-0.5 transition-transform"></i>
            </div>
            Open XM Account Now
            <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
          </a>
          <Link
            to="/compare/xm-vs-tickmill"
            className="inline-flex items-center gap-2 px-8 py-4 border border-[#374151] hover:border-[#7C3AED] text-[#F8FAFC] font-semibold rounded-lg transition-all hover:bg-[#1F2937] whitespace-nowrap"
          >
            Compare with Other Brokers
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default function Home() {
  useSEO({
    /* @replace:home-title */

    title: 'XM Broker Comparison 2026 | Compare XM with Top Forex Brokers',
    /* @replace:home-description */

    description: 'Compare XM with other forex brokers in 2026. Analyze trading fees, spreads, account types, platforms, regulations, and features to understand how XM compares with alternative brokers.',
    /* @replace:home-keywords */

    keywords: 'XM broker comparison, XM review, XM vs forex brokers, forex broker comparison, XM trading platform, forex broker analysis',
    /* @replace:home-canonical */

    canonical: '/',
  });

  return (
    <div>
      <HeroSection />
      <AdvantagesSection />
      <MarketDashboard />
      <AccountTypesSection />
      <ProsConsSection />
      <OnboardingSection />
      <FundingSection />
      <ExpertVerdictSection />
      <FaqSection />
      <FinalCTA />
    </div>
  );
}